export function createSentence(prefix: string, words: string[]) {
	return (
		prefix +
		words.filter(Boolean).reduce((accumulator, currentWord, currentIndex, array) => {
			const isLastWord = currentIndex === array.length - 1;
			const isSecondToLastWord = currentIndex === array.length - 2;
			const isMoreThanOneWord = array.length > 1;

			const finalWord =
				isMoreThanOneWord && isSecondToLastWord ? `${currentWord} e ` : currentWord;

			return accumulator + `${finalWord}${isLastWord || isSecondToLastWord ? "" : ", "}`;
		}, "")
	);
}
